import React from "react";
import SaleDashboard from "./widgets/page";

const SaleDashboardPage = () => {
    return <SaleDashboard />;
};

export default SaleDashboardPage;
